import { Injectable } from '@angular/core';
import { Category } from '../../../../core/models/category.model';
import { Observable } from 'rxjs';
import { CategoriesServiceAdapter } from '../../../../core/integrations/nosERP/services/categories.service.adapter';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  constructor(private categoriesServiceAdapter: CategoriesServiceAdapter) {}

  getCategories(): Observable<Category[]> {
    return this.categoriesServiceAdapter.getCategories();
  }

  fetchCategories(): Observable<Category[]> {
    return this.categoriesServiceAdapter.fetchCategories();
  }

  clearCategoriesCache(): void {
    this.categoriesServiceAdapter.clearCategoriesCache();
  }

  public static buildBreadcrumb(categories: Category[], clickedCategoryId: string): Category[] {
    const breadcrumb: Category[] = [];
    let currentCategory: Category | undefined = categories.find(category => category.id === clickedCategoryId);

    while (currentCategory) {
      breadcrumb.unshift(currentCategory); // Add the current category to the beginning of the array
      currentCategory = categories.find(category => currentCategory?.parentCategory?.id === category.id); // Move to the parent category
    }

    return breadcrumb; // Final breadcrumb array with categories from root to current

    // return CategoriesServiceAdapter.buildBreadcrumb(categories, clickedCategoryId);
  }
}
